import React from 'react';
import { Repeat } from 'lucide-react';

// 04-enforce.md 4.1 -- extraído de NewEvent.jsx: el bloque de "evento recurrente" (toggle +
// opciones diaria/semanal/mensual/anual + selector de días para la semanal). Presentacional.
const DAY_VALUES = [1, 2, 3, 4, 5, 6, 0]; // L=1, M=2, X=3, J=4, V=5, S=6, D=0

const NeRecurrenceField = ({ isRecurring, setIsRecurring, recurrenceType, setRecurrenceType, selectedWeekDays, setSelectedWeekDays, t }) => {
  const toggleRecurring = () => {
    const next = !isRecurring;
    setIsRecurring(next);
    if (next && recurrenceType === 'none') setRecurrenceType('daily');
    else if (!next) setRecurrenceType('none');
  };

  const toggleWeekDay = (dayVal) => {
    setSelectedWeekDays(prev => prev.includes(dayVal) ? prev.filter(d => d !== dayVal) : [...prev, dayVal]);
  };

  const options = [
    { id: 'daily', label: t('eventModal.recurrence.daily') },
    { id: 'weekly', label: t('eventModal.recurrence.weekly') },
    { id: 'monthly', label: t('eventModal.recurrence.monthly') },
    { id: 'yearly', label: t('eventModal.recurrence.yearly') },
  ];

  return (
    <div className="ne-row" style={{ alignItems: 'flex-start' }}>
      <Repeat size={18} className="ne-icon" style={{ marginTop: 'var(--space-3)' }} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)', width: '100%' }}>
        <button
          onClick={toggleRecurring}
          className={`ne-recurring-btn ${isRecurring ? 'active' : ''}`}
          style={{
            background: isRecurring ? '#3b82f6' : '#333',
            color: isRecurring ? 'white' : '#ccc',
            border: 'none',
            borderRadius: 'var(--radius-xl)',
            padding: 'var(--space-2) var(--space-4)',
            cursor: 'pointer',
            fontWeight: '500',
            width: 'fit-content',
            fontSize: '13px',
            transition: 'all 0.2s',
            marginTop: 'var(--space-2)'
          }}
        >
          {t('eventModal.recurringButton')}
        </button>

        {isRecurring && (
          <div className="ne-recurrence-options" style={{
            background: '#222', padding: 'var(--space-3)', borderRadius: 'var(--radius-md)', border: '1px solid #333',
            display: 'flex', flexDirection: 'column', gap: 'var(--space-2)'
          }}>
            {options.map(opt => (
              <div key={opt.id} style={{ display: 'flex', flexDirection: 'column' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)', cursor: 'pointer', color: '#ddd', fontSize: '13px' }}>
                  <input
                    type="radio"
                    name="recurrence"
                    value={opt.id}
                    checked={recurrenceType === opt.id}
                    onChange={() => setRecurrenceType(opt.id)}
                    style={{ accentColor: '#3b82f6' }}
                  />
                  <span>{opt.label}</span>
                </label>

                {opt.id === 'weekly' && recurrenceType === 'weekly' && (
                  <div className="ne-week-days-selector" style={{ display: 'flex', gap: 'var(--space-1)', marginTop: 'var(--space-2)', marginLeft: 'var(--space-6)' }}>
                    {t('eventModal.recurrence.weekDayLetters', { returnObjects: true }).map((label, idx) => {
                      const dayVal = DAY_VALUES[idx];
                      const isSelected = selectedWeekDays.includes(dayVal);
                      return (
                        <button
                          key={label}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleWeekDay(dayVal); }}
                          style={{
                            width: '24px', height: '24px', borderRadius: '50%',
                            background: isSelected ? '#3b82f6' : 'transparent',
                            color: isSelected ? 'white' : '#888',
                            border: isSelected ? 'none' : '1px solid #444',
                            fontSize: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer'
                          }}
                        >
                          {label}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NeRecurrenceField;
